import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'signup_auth_params_security.title',
  },
  subTitle: {
    id: 'signup_auth_params_security.sub_title',
  },
  password: {
    id: 'signup_auth_params_security.password',
  },
  passwordMsg: {
    id: 'signup_auth_params_security.password_msg',
  },
  confirmPassword: {
    id: 'signup_auth_params_security.confirm_password',
  },
  questionTitle: {
    id: 'signup_auth_params_security.title2',
  },
  question: {
    id: 'signup_auth_params_security.question_secret',
  },
  response: {
    id: 'signup_auth_params_security.response',
  },
  loiParagraph: {
    id: 'signup_personal_info.loi_paragraph',
  },
  contacterParSaham: {
    id: 'signup_personal_info.contacter_par_saham',
  },
  iAccept: {
    id: 'id_memo.i_accept',
  },
  termsAndConditions: {
    id: 'id_memo.terms_and_conditions',
  },
  personalData: {
    id: 'id_memo.personal_data',
  },
  requiredField: {
    id: 'required.field',
  },
  shortContent: {
    id: 'shortContent.field',
  },
  confirmPasswordError: {
    id: 'signup_create_password.confirm_password.error',
  },
  suivant: {
    id: 'signup_auth_button.next',
  },
  precedent: {
    id: 'signup_auth_button.previous',
  },
  modalTitle: {
    id: 'modal.Title',
  },
  close: {
    id: 'modal.close',
  },
  accept: {
    id: 'modal.accept',
  },
});
